import React, { forwardRef } from "react"
import { Input, Label } from "@ui/shad"
import { cn } from "@ui/utils"

interface FileInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange" | "value" | "type"> {
  id: string
  label?: string
  error?: boolean
  onChange?: (file: File | null) => void
}

export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ label, error, id, onChange, ...props }, ref) => {
    return (
      <div className="space-y-1">
        {label && (
          <Label htmlFor={id} className={cn(error && "text-destructive")}>
            {label}
          </Label>
        )}
        <Input
          type="file"
          ref={ref}
          id={id}
          onChange={(e) => {
            const file = e.target.files?.[0] || null
            onChange?.(file)
          }}
          {...props}
        />
      </div>
    )
  }
)

FileInput.displayName = "FileInput"
